(function () {
  'use strict';
  if (window.BumpinoFitGuide) {
    window.BumpinoFitGuide.init(document);
    return;
  }
  var ranges = [
    { key: 's', min: 55, max: 56, aliases: ['s', 'small', '36', '36(s)', 'صغير'] },
    { key: 'm', min: 65, max: 75, aliases: ['m', 'medium', '38', '38(m)', 'متوسط'] },
    { key: 'l', min: 76, max: 85, aliases: ['l', 'large', '40', '40(l)', 'كبير'] },
    { key: 'xl', min: 85, max: 95, aliases: ['xl', 'xlarge', '42', '42(xl)'] },
    { key: '2xl', min: 95, max: 110, aliases: ['2xl', 'xxl', '44', '44(2xl)', '44(xxl)'] },
    { key: '3xl', min: 110, max: 125, aliases: ['3xl', 'xxxl', '46', '46(3xl)', '46(xxxl)'] }
  ];
  function normalize(value) {
    return String(value).trim().toLowerCase().replace(/[\s_-]/g, '');
  }
  function match(weight, sizes) {
    var valid = Number.isFinite(weight) && weight > 0;
    var matchingRanges = valid ? ranges.filter(function (range) { return weight >= range.min && weight <= range.max; }) : [];
    var candidates = (sizes || []).filter(function (value) {
      return matchingRanges.some(function (range) { return range.aliases.indexOf(normalize(value)) !== -1; });
    });
    return { valid: valid, overlap: matchingRanges.length > 1, candidates: candidates };
  }
  var mounted = new WeakSet();
  function mount(root) {
    if (mounted.has(root)) return;
    var dataNode = root.querySelector('[data-bumpino-fit-data]');
    var weightInput = root.querySelector('[data-bumpino-fit-weight]');
    var check = root.querySelector('[data-bumpino-fit-check]');
    var output = root.querySelector('[data-bumpino-fit-result]');
    var config;
    try { config = JSON.parse(dataNode.textContent); } catch (error) { return; }
    if (!weightInput || !check || !output) return;
    mounted.add(root);
    var hasResult = false;
    function render() {
      hasResult = true;
      var raw = weightInput.value.trim();
      var result = match(raw ? Number(raw) : NaN, config.sizes);
      output.replaceChildren();
      var message = document.createElement('p');
      message.textContent = config.messages[!result.valid ? 'fit_invalid' : !result.candidates.length ? 'fit_no_match' : result.overlap ? 'fit_overlap' : 'fit_result'];
      output.appendChild(message);
      if (!result.candidates.length) return;
      var info = root.closest('.t4s-product__info-container, .t4s-product-quick-shop, .t4s-product-quick-view') || root.parentElement;
      var form = info.querySelector('form[data-type="add-to-cart-form"]');
      var selected = {};
      if (form) form.querySelectorAll('[data-swatch-option]').forEach(function (option) {
        var item = option.querySelector('[data-swatch-item].is--selected');
        if (item) selected[Number(option.getAttribute('data-id'))] = item.getAttribute('data-value');
      });
      var otherCount = config.variants.length ? config.variants[0].options.length - 1 : 0;
      var selectedCount = Object.keys(selected).filter(function (index) { return Number(index) !== config.sizeIndex; }).length;
      var complete = selectedCount >= otherCount;
      var list = document.createElement('ul');
      result.candidates.forEach(function (size) {
        var variants = config.variants.filter(function (variant) {
          return variant.options[config.sizeIndex] === size && Object.keys(selected).every(function (index) {
            return Number(index) === config.sizeIndex || variant.options[Number(index)] === selected[index];
          });
        });
        var status = !complete ? 'fit_pick_options' : !variants.length ? 'fit_unavailable' : variants.some(function (variant) { return variant.available; }) ? 'fit_available' : 'fit_soldout';
        var item = document.createElement('li');
        item.textContent = size + ' — ' + config.messages[status];
        list.appendChild(item);
      });
      output.appendChild(list);
    }
    check.addEventListener('click', render);
    weightInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') { event.preventDefault(); render(); }
    });
    var info = root.closest('.t4s-product__info-container') || root.parentElement;
    info.addEventListener('click', function (event) {
      if (hasResult && event.target.closest('[data-swatch-item]')) window.setTimeout(render, 0);
    });
    info.addEventListener('change', function () { if (hasResult) window.setTimeout(render, 0); });
    if (window.jQuery_T4NT) window.jQuery_T4NT(info).on('variant:changed', function () { if (hasResult) render(); });
  }
  function init(scope) { scope.querySelectorAll('[data-bumpino-fit-guide]').forEach(mount); }
  window.BumpinoFitGuide = { match: match, init: init };
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
